var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtocart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.856 9.58575H12.9454C12.5096 9.58575 12.1579 9.23295 12.1579 8.79824C12.1579 8.36354 12.5096 8.01074 12.9454 8.01074H15.856C16.2907 8.01074 16.6435 8.36354 16.6435 8.79824C16.6435 9.23295 16.2907 9.58575 15.856 9.58575Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.853241C0 0.43379 0.3467 0.09375 0.774371 0.09375H1.53267C2.96462 0.09375 4.17249 1.13955 4.3501 2.53315L4.55545 4.14439H19.1928C20.2974 4.14439 21.1435 5.10798 20.9796 6.17943L19.8726 13.4183C19.6641 14.7815 18.4701 15.79 17.0646 15.79H7.19892C5.79345 15.79 4.59947 14.7815 4.39099 13.4183L3.10604 5.01655L3.10345 4.99809L2.81331 2.72155C2.73258 2.0881 2.18355 1.61274 1.53267 1.61274H0.774371C0.3467 1.61274 0 1.2727 0 0.853241ZM4.77104 5.66338L5.92259 13.193C6.01735 13.8126 6.56007 14.271 7.19892 14.271H17.0646C17.7035 14.271 18.2462 13.8126 18.341 13.193L19.448 5.9541C19.4714 5.80103 19.3506 5.66338 19.1928 5.66338H4.77104Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3245 19.0841C18.3245 19.6434 17.8622 20.0968 17.292 20.0968C16.7218 20.0968 16.2595 19.6434 16.2595 19.0841C16.2595 18.5249 16.7218 18.0715 17.292 18.0715C17.8622 18.0715 18.3245 18.5249 18.3245 19.0841Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00145 19.0841C8.00145 19.6434 7.53918 20.0968 6.96895 20.0968C6.39872 20.0968 5.93646 19.6434 5.93646 19.0841C5.93646 18.5249 6.39872 18.0715 6.96895 18.0715C7.53918 18.0715 8.00145 18.5249 8.00145 19.0841Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtocart);
export default __webpack_public_path__ + "static/media/addtocart.bceca5ccaf30ac149c71adde16e0c2f4.svg";
export { ForwardRef as ReactComponent };